var map = {
	"./0x.svg": 265,
	"./basic-attention-token.svg": 266,
	"./binance-coin.svg": 267,
	"./bitcoin-cash.svg": 268,
	"./bitcoin.svg": 269,
	"./cardano.svg": 270,
	"./dash.svg": 271,
	"./decred.svg": 272,
	"./enigma.svg": 273,
	"./eos.svg": 274,
	"./ethereum.svg": 275,
	"./iota.svg": 276,
	"./litecoin.svg": 277,
	"./monero.svg": 278,
	"./nano.svg": 279,
	"./pax-gold.svg": 280,
	"./ripple.svg": 281,
	"./stellar.svg": 282,
	"./tezos.svg": 283,
	"./trueusd.svg": 284,
	"./waves.svg": 285,
	"./zencash.svg": 286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 264;